import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import { SavePrepForInstallChecklistFormParams } from "../types/SavePrepForInstallChecklistFormParams";
import { SaveCallScriptFormResult } from "../types/SaveCallScriptFormResult";

export const useSavePrepForInstallChecklistForm = (
	params: SavePrepForInstallChecklistFormParams,
	onSuccess: (result: SaveCallScriptFormResult) => void,
	onError: (error: string) => void) => {

	let method = '';
	let requestParams: any;
	method = 'save-installChecklistForm';
	requestParams = {
		RetailOrderID: params.formObject.RetailOrderID,
		RetailOrderNo: params.formObject.RetailOrderNo,
		MayISpeakTo: params.formObject.MayISpeakTo,
		IntroduceTourself: params.formObject.IntroduceTourself,
		ScheduleProject: params.formObject.ScheduleProject,
		LowesSurveyScore: params.formObject.LowesSurveyScore,
		DecisionMaker: params.formObject.DecisionMaker,
		PriorToTheArrival: params.formObject.PriorToTheArrival,
		RemoveExistingCountertop: params.formObject.RemoveExistingCountertop,
		AllApplicancesMustBeRemoved: params.formObject.AllApplicancesMustBeRemoved,
		ClearEntryWay: params.formObject.ClearEntryWay,
		ReconnectPlumbing: params.formObject.ReconnectPlumbing,
		BeforeWipingDown: params.formObject.BeforeWipingDown,
		FinalWallPreparation: params.formObject.FinalWallPreparation,
		Provide4Hour: params.formObject.Provide4Hour,
		LowesSurveyPerfect: params.formObject.LowesSurveyPerfect,
		ThankCustomerForPurchase: params.formObject.ThankCustomerForPurchase,
		NoteText: params.formObject.NoteText
	};

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/" + method, requestParams) as SaveCallScriptFormResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
			{
				onSuccess(result);
			}
			else
				onError(`Error when saving the pdf file"}: ` +
					result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}